import PassoInformacoesPessoais         from './PassoInformacoesPessoais'
import PassoEndereco                    from './PassoEndereco'
import PassoOutrasInformacoes           from './PassoOutrasInformacoes'
import PassoDadosBancarios              from './PassoDadosBancarios'
import PassoEnvioIdentidade             from './PassoEnvioIdentidade'
import PassoEnvioComprovanteResidencia  from './PassoEnvioComprovanteResidencia'
import PassoComoNosConheceu             from './PassoComoNosConheceu'
import PassoConfirmacaoCadastro         from './PassoConfirmacaoCadastro'
import PassoConcluido                   from './PassoConcluido'


const steps = {
  'informacoes-pessoais':            PassoInformacoesPessoais,
  'endereco':                        PassoEndereco,
  'outras-informacoes':              PassoOutrasInformacoes,
  'dados-bancarios':                 PassoDadosBancarios,
  'envio-identidade':                PassoEnvioIdentidade,
  'envio-comprovante-residencia':    PassoEnvioComprovanteResidencia,
  'como-nos-conheceu':               PassoComoNosConheceu,
  'confirmacao-cadastro':            PassoConfirmacaoCadastro,
  'cadastro-concluido':              PassoConcluido
}
export default steps



// WEBPACK FOOTER //
// ./src/components/AdditionalInformationInvestor/index.js